
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"25","viewBox":"0 0 38 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#0A5792","stroke":"#0A5792","stroke-width":".4","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M17.658 45.094a.787.787 0 01-.497-.18.763.763 0 01-.063-1.06l2.336-2.691-.612-.017a17.945 17.945 0 01-1.893-.16 17.012 17.012 0 01-2.99-.665c-4.704-1.46-8.543-4.653-10.812-8.992-2.29-4.333-2.748-9.307-1.29-14.006a18.551 18.551 0 014.7-7.703 18.441 18.441 0 017.83-4.526.71.71 0 01.21-.032c.325 0 .618.223.714.541a.739.739 0 01-.067.573.719.719 0 01-.447.342 17.12 17.12 0 00-7.194 4.17 16.718 16.718 0 00-4.316 7.069A16.808 16.808 0 004.432 30.63a16.847 16.847 0 009.934 8.277c.886.268 1.813.474 2.76.61.608.082 1.239.132 1.929.154l.565.016-2.093-3.085a.74.74 0 01.198-1.038.733.733 0 01.408-.127.76.76 0 01.621.333l2.862 4.212a.748.748 0 01-.026.954l-3.378 3.907a.728.728 0 01-.554.25M24.153 40.407a.755.755 0 01-.715-.55.758.758 0 01.522-.92 16.89 16.89 0 007.198-4.169 16.932 16.932 0 004.314-7.048 16.947 16.947 0 00-1.175-12.89c-2.11-4.003-5.638-6.937-9.936-8.264a16.385 16.385 0 00-2.762-.61 16.4 16.4 0 00-1.91-.152l-.559-.012 2.074 3.079a.738.738 0 01.117.567.697.697 0 01-.302.451.74.74 0 01-1.04-.187l-2.862-4.227a.736.736 0 01.023-.939L20.515.632a.74.74 0 01.562-.25c.18 0 .353.062.486.175.149.13.241.318.253.52a.706.706 0 01-.177.524L19.3 4.29l.601.025a18.8 18.8 0 011.895.16c1.017.145 2.025.368 2.997.663 4.7 1.472 8.54 4.671 10.811 9.009 2.287 4.332 2.744 9.306 1.285 14.006a18.48 18.48 0 01-4.695 7.688 18.613 18.613 0 01-7.834 4.537.723.723 0 01-.207.03"}})])])
          )
        }
      }
    